module.exports = __webpack_public_path__ + "img/dloons_01.14eb0b6e.png";